import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function VSL() {
  const navigate = useNavigate();
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Scroll to top when the component mounts
    window.scrollTo(0, 0);
    // Slight delay before showing the content for a smooth entrance animation
    const timer = setTimeout(() => setShowContent(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-950 via-gray-900 to-gray-950 text-white">
      <meta name="robots" content="noindex, nofollow" />
      {/* Navbar simple */}
      <nav className="w-full py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center">
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              navigate('/');
            }}
            className="cursor-pointer"
          >
            <img
              src="https://static.readdy.ai/image/857147547f7da499a0fc7d35aaf6d8ec/512cce5c00ccd36955d2d4e00fd25839.png"
              alt="Usine à Leads"
              className="h-10 w-auto"
            />
          </a>
        </div>
      </nav>

      {/* Contenu principal */}
      <main
        className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 transition-all duration-700 ${
          showContent ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
      >
        {/* Remerciement */}
        <section className="text-center mb-10 sm:mb-14">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-500/20 mb-6">
            <i className="ri-checkbox-circle-fill text-3xl text-emerald-400"></i>
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 leading-tight">
            Merci pour votre demande&nbsp;!
          </h1>
          <p className="text-lg sm:text-xl text-white/70 max-w-2xl mx-auto leading-relaxed">
            Votre message a bien été envoyé. Avant que notre équipe vous recontacte, découvrez en
            7 minutes comment nous générons des leads qualifiés pour nos clients.
          </p>
        </section>

        {/* Video Placeholder */}
        <section className="mb-10 sm:mb-14">
          <div
            className="relative w-full rounded-2xl overflow-hidden shadow-2xl shadow-orange-500/10 border border-white/10 bg-gray-800"
            style={{ aspectRatio: '16/9' }}
          >
            {/* Placeholder vidéo */}
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
              <div className="w-20 h-20 rounded-full bg-orange-500/20 flex items-center justify-center cursor-pointer hover:bg-orange-500/30 transition-all duration-300 group">
                <i className="ri-play-fill text-4xl text-orange-400 group-hover:text-orange-300 ml-1"></i>
              </div>
              <p className="text-white/50 text-sm font-medium">Vidéo à venir</p>
            </div>
            {/* Remplacer ce div par une iframe ou un lecteur vidéo */}
          </div>
        </section>

        {/* CTA Calendly */}
        <section className="text-center mb-16 sm:mb-20">
          <div className="bg-gradient-to-br from-white/5 to-white/[0.02] rounded-2xl border border-white/10 p-8 sm:p-12">
            <h2 className="text-2xl sm:text-3xl font-bold mb-3">
              Prêt à passer à l&apos;action&nbsp;?
            </h2>
            <p className="text-white/60 mb-8 text-base sm:text-lg max-w-xl mx-auto">
              Réservez un appel stratégique de 30 minutes avec notre équipe. C&apos;est gratuit et
              sans engagement.
            </p>
            <button
              data-iclosed-link="https://app.iclosed.io/e/usinealead/rdv-45-min-votre-business-votre-besoin"
              data-embed-type="popup"
              className="inline-flex items-center gap-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 sm:px-10 py-4 rounded-xl font-bold text-base sm:text-lg hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-lg shadow-orange-500/30 hover:shadow-xl hover:shadow-orange-500/40 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-xl"></i>
              Réserver mon appel gratuit
            </button>
            <div className="flex flex-wrap items-center justify-center gap-6 mt-6 text-sm text-white/50">
              <span className="flex items-center gap-2">
                <i className="ri-time-line text-orange-400"></i>
                30 min
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-vidicon-line text-orange-400"></i>
                Visio ou téléphone
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-shield-check-line text-orange-400"></i>
                Sans engagement
              </span>
            </div>
          </div>
        </section>
      </main>

      {/* Footer minimal */}
      <footer className="border-t border-white/10 py-6">
        <div className="max-w-7xl mx-auto px-4 text-center text-xs text-white/40">
          © {new Date().getFullYear()} Usine à Leads. Tous droits réservés.
        </div>
      </footer>
    </div>
  );
}
